// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_p_0","cls2":"SingleClaimPage-cls2_h6y SingleClaimPage-cls1_p_0"};